import * as React from 'react';
import styles from './MyTipsTipBox.module.scss';
import SVG from 'react-inlinesvg';
import icon from '../../assets/icons/icons-tips.svg';

import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Confidence } from '../Shops/Tip/components/TipBox/Bottom/Confidence';
import { TipValueWithLabel } from '../Shops/Tip/components/TipValueWithLabel/TipValueWithLabel';

export interface BetProps {
  data: any;
  EditTip?: boolean;
  selectBet: (values: any) => any;
  oddsFormat: string;
}

export const ClosedLiveBet: React.FC<BetProps> = ({
  data,
  EditTip,
  selectBet,
  oddsFormat,
  ...props
}) => {
  const { t } = useTranslation();

  const cx = classNames.bind(styles);
  return (
    <div className={cx(styles.container, styles.LIVE)}>
      <div className={styles.header}>
        <SVG className={styles.icon} src={icon} />
        <span className={styles.text}>{tr(t, 'live_tip')}</span>
      </div>
      <div className={styles.border}>
        <div className={styles.innerTopBox}>
          <img
            src={data.betslip_image.url}
            alt="betslip"
            className={styles.betSlipImg}
          />
        </div>
        <div className={styles.innerBottomBox}>
          <Confidence confidence={data.confidence} stake={data.stake} />

          <TipValueWithLabel label={tr(t, 'odd')}>
            {/* @ts-ignore */}
            {data.rate === 0
              ? 0
              : data.formatted_odds[oddsFormat.toLowerCase()]}
          </TipValueWithLabel>
          <div className={styles.bookieTag}>
            <div className={styles.bookieTagInner}>
              <label>
                {tr(t, 'bet_done_at')} <span>{data.bookie}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
